import { FiscalCstPis } from './../../model/fiscal/fiscalCstPis';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GenericService } from '../generics/generic.service';
import { AutoRegisterService } from '../generics/servicesRegistry';

@Injectable({
  providedIn: 'root'
})
@AutoRegisterService()
export class FiscalCstPisService extends GenericService<FiscalCstPis> {
  constructor(http: HttpClient) {
    super(http);
    super.initResource("fiscalcstpis")
  }
}
